// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"fb648a0c","498":"a85f490d","598":"db4366e6","703":"c0f6d333"}[chunkId] + ".chunk.js";
};